import { breakpoints, useMatchMedia, useMediaQuery } from '@frontend/responsiveness';

export const useIsMobile = (maxWidth?: number): boolean => {
  const isSmall = useMatchMedia({ maxWidth: maxWidth ?? breakpoints.small.max });
  const isScreen = useMediaQuery('screen');
  return isSmall && isScreen;
};
